export const translationData: {[key: number]: string} = {
    1: 'ข้อกำหนดและเงื่อนไขการใช้บริการ',
    2: 'Disclaimer',
    3: 'Act 1.',
    4: 'Act 2.',
    5: 'Act 3.',
    6: 'Act 4.',
    7: 'Act 5.',
    8: 'Privacy notice',
    9: 'Agree',
    10: 'Page Not Found',
    11: 'Something when wrong',
    12: 'กรุณารอสักครู่',
    13: 'Not mobile',
    14: 'เกิดข้อผิดพลาด',
    15: 'ระบบไม่สามารถส่งข้อมูลได้',
    16: 'ลองใหม่อีกครั้ง',
    17: 'นโยบายความเป้นส่วนตัว',
    18: 'Act 6.',
    19: 'ข้อกำหนดและเงื่อนไขการใช้บริการ',
    20: 'prelude',
    21: 'topic 1',
    22: 'key 1',
    23: 'mean 1',
    24: 'key 2',
    25: 'mean 2',
    26: 'key 3',
    27: 'mean 3',
    28: 'key 4',
    29: 'mean 4',
    30: 'key 5',
    31: 'mean 5',
    32: 'key 6',
    33: 'mean 6',
    34: 'key 7',
    35: 'mean 7',
    36: 'key 8',
    37: 'mean 8',
    38: 'key 9',
    39: 'mean 9',
    40: 'key 10',
    41: 'mean 10',
    42: 'topic 2',
    43: '2.1',
    44: '2.2',
    45: '2.2.1',
    46: '2.2.2',
    47: '2.2.3',
    48: '2.2.3.1',
    49: '2.2.4',
    50: '2.2.5',
    51: '2.3',
    52: '2.4',
    53: 'topic 3',
    54: '3.1',
    55: '3.2',
    56: 'topic 4',
    57: '4.1',
    58: '4.2',
    59: '4.3',
    60: '4.4',
    61: '4.5',
    62: '4.6',
    63: '4.7',
    64: '4.8',
    65: '4.9',
    66: '4.10',
    67: '4.11',
    68: '4.12',
    69: 'topic 5',
    70: 'detail 5',
    71: 'topic 6',
    72: '6.1',
    73: '6.2',
    74: '6.3',
    75: 'topic 7',
    76: '7.1',
    77: '7.1.1',
    78: '7.1.2',
    79: '7.1.3',
    80: '7.1.4',
    81: '7.2',
    82: 'topic 8',
    83: '8.1',
    84: '8.2',
    85: '8.3',
    86: 'topic 9',
    87: '9.1',
    88: '9.2',
    89: 'topic 10',
    90: 'detail 10',
    91: 'Questionaire',
    92: 'ยินดีต้อนรับ {0}',
    93: 'ให้ส่งข่าวสารให้ได้ตรงใจ{0}',
    94: 'Next',
    95: 'Welcome',
    96: 'ขอขอบคุณ {0}',
    97: 'จะบรรจงคัดสรรมาให้ {0}',
    98: 'เริ่มต้น',
    99: 'Saving',
    100: 'ลงทะเบียน',
    101: 'กรุณากรอกข้อมูล',
    102: 'บัตรประชาชน',
    103: 'เลขบัตร',
    104: 'โทรศัพท์',
    105: 'กรุณากรอกเลขโทรศัพท์',
    106: 'Login',
    107: 'หนังสือ',
    108: 'เลขที่',
    109: 'Country',
    110: 'Alien card',
    111: 'Alien number',
    112: 'Confirm OTP',
    113: 'Input OTP from number {0}',
    114: 'Ref: {0}',
    115: 'No SMS ?',
    116: 'Send again',
    117: 'Read more',
    118: 'Here',
    119: 'Wrong OTP',
    120: 'Wait {0} seconds',
    121: 'Sorry, OTP exceed limit',
    122: 'Please register again',
    123: 'Close',
    124: 'Privacy Notice Title 1',
    125: 'Privacy Notice Title 2',
    126: 'Instruction 1',
    127: 'Instruction 2',
    128: 'Persons',
    129: 'Person 1',
    130: 'Person 1.1 title',
    131: 'Person 1.1 detail',
    132: 'Person 1.2 title',
    133: 'Person 1.2 detail',
    134: 'Person 2',
    135: 'Person 2 detail',
    136: 'Instruction 3',
    137: 'Act 1',
    138: 'Act 1 Instruction',
    139: 'Act 1.1',
    140: 'Act 1.1 Instruction',
    141: 'Act 1.1.1',
    142: 'Act 1.1.2',
    143: 'Act 1.1.3',
    144: 'Act 1.2',
    145: 'Act 1.2 Instruction',
    146: 'Act 1.2.1',
    147: 'Act 1.2.2',
    148: 'Act 1.2.3',
    149: 'Act 1.2.4',
    150: 'Act 1.2.5',
    151: 'Act 1.2.6',
    152: 'Act 1.2.7',
    153: 'Act 1.2.8',
    154: 'Act 1.2.9',
    155: 'Act 1.2.10',
    156: 'Act 1.2.11',
    157: 'Act 1.2.12',
    158: 'Act 1.2.13',
    159: 'Act 1.2.14',
    160: 'Act 1.3',
    161: 'Act 1.3 Instruction',
    162: 'Act 1.3.1',
    163: 'Act 1.3.2',
    164: 'Act 1.3.3',
    165: 'Act 1.3.4',
    166: 'Act 1.3.5',
    167: 'Act 1.3.6',
    168: 'Act 1.3.7',
    169: 'Act 1.3.8',
    170: 'Act 1.3.9',
    171: 'Act 1.3.10',
    172: 'Act 1.3.11',
    173: 'Act 1.3.12',
    174: 'Act 1.3.13',
    175: 'Act 1.3.14',
    176: 'Act 1.3.15',
    177: 'Act 1.3.16',
    178: 'Act 1.3.17',
    179: 'Act 1.3.18',
    180: 'Act 1.3.19',
    181: 'Act 1.4',
    182: 'Act 1.4 Instruction',
    183: 'Act 1.4.1',
    184: 'Act 1.4.2',
    185: 'Act 1.4.3',
    186: 'Act 1.4.4',
    187: 'Act 1.4.5',
    188: 'Act 1.5',
    189: 'Act 1.5 Instruction 1',
    190: 'Act 1.5.1',
    191: 'Act 1.5.2',
    192: 'Act 1.5.3',
    193: 'Act 1.5 Instruction 2',
    194: 'Act 2',
    195: 'Act 2 Instruction',
    196: 'Act 2 Table Header 1',
    197: 'Act 2 Table Header 2',
    198: 'Act 2.1',
    199: 'Act 2.1.1',
    200: 'Act 2.1.2',
    201: 'Act 2.1.3',
    202: 'Act 2.1.4',
    203: 'Act 2.1.5',
    204: 'Act 2.1.6',
    205: 'Act 2.1.7',
    206: 'Act 2.1.8',
    207: 'Act 2.1.9',
    208: 'Act 2.1.10',
    209: 'Act 2.2',
    210: 'Act 2.2.1',
    211: 'Act 2.2.2',
    212: 'Act 2.2.3',
    213: 'Act 2.2.4',
    214: 'Act 2.2.5',
    215: 'Act 2.2.6',
    216: 'Act 2.2.7',
    217: 'Act 2.2.8',
    218: 'Act 2.2.9',
    219: 'Act 2.3',
    220: 'Act 2.3.1',
    221: 'Act 2.3.2',
    222: 'Act 2.3.3',
    223: 'Act 2.3.4',
    224: 'Act 2.3.5',
    225: 'Act 2.3.6',
    226: 'Act 2.3.7',
    227: 'Act 2.4',
    228: 'Act 2.4.1',
    229: 'Act 2.4.2',
    230: 'Act 2.4.3',
    231: 'Act 2.4.4',
    232: 'Act 2.4.5',
    233: 'Act 2.4.6',
    234: 'Act 2.4.7',
    235: 'Act 2.4.8',
    236: 'Act 2.5',
    237: 'Act 2.5.1',
    238: 'Act 2.5.2',
    239: 'Act 2.5.3',
    240: 'Act 2.5.4',
    241: 'Act 2.5.5',
    242: 'Act 2.5.6',
    243: 'Act 2.5.7',
    244: 'Act 2.5.8',
    245: 'Act 2.5.9',
    246: 'Act 2.5.10',
    247: 'Act 2.5.11',
    248: 'Act 2.5.12',
    249: 'Act 2.5.13',
    250: 'Act 2.5.14',
    251: 'Act 2.5.15',
    252: 'Act 2.5.16',
    253: 'Act 2.5.17',
    254: 'Act 2.5.18',
    255: 'Act 2.5.19',
    256: 'Act 2.5.20',
    257: 'Act 2.5.21',
    258: 'Act 2.5.22',
    259: 'Act 2.5.23',
    260: 'Act 2.5.24',
    261: 'Act 2.5.25',
    262: 'Act 2.5.26',
    263: 'Act 2.5.27',
    264: 'Act 2.5.28',
    265: 'Act 2.5.29',
    266: 'Act 2.5.30',
    267: 'Act 2.5.31',
    268: 'Act 2.5.32',
    269: 'Act 2.5.33',
    270: 'Act 2.5.34',
    271: 'Act 2.5.35',
    272: 'Act 2.5.36',
    273: 'Act 2.5.37',
    274: 'Act 2.5.38',
    275: 'Act 2.5.39',
    276: 'Act 2.5.40',
    277: 'Act 2.5.41',
    278: 'Act 2.5.42',
    279: 'Act 2.5.43',
    280: 'Act 2.5.44',
    281: 'Act 2.5.45',
    282: 'Act 2.5.46',
    283: 'Act 2.5.47',
    284: 'Act 2.6',
    285: 'Act 2.6.1',
    286: 'Act 2.6.2',
    287: 'Act 2.6.3',
    288: 'Act 2.6.4',
    289: 'Act 2.6.5',
    290: 'Act 2.7',
    291: 'Act 2.7.1',
    292: 'Act 2.7.2',
    293: 'Act 2.7.3',
    294: 'Act 2.7.4',
    295: 'Act 2.8',
    296: 'Act 2.8.1',
    297: 'Act 2.8.2',
    298: 'Act 2.9',
    299: 'Act 2.9.1',
    300: 'Act 2.9.2',
    301: 'Act 2.9.3',
    302: 'Act 2.9.4',
    303: 'Act 2.9.5',
    304: 'Act 2.9.6',
    305: 'Act 2.9.7',
    306: 'Act 2.9.8',
    307: 'Act 2.10',
    308: 'Act 2.10.1',
    309: 'Act 2.10.2',
    310: 'Act 2.11',
    311: 'Act 2.11.1',
    312: 'Act 2.11.2',
    313: 'Act 2.11.3',
    314: 'Act 2.11.4',
    315: 'Act 2.11.5',
    316: 'Act 2.12',
    317: 'Act 2.12.1',
    318: 'Act 2.12.2',
    319: 'Act 2.12.3',
    320: 'Act 2.13',
    321: 'Act 2.13.1',
    322: 'Act 2.13.2',
    323: 'Act 3',
    324: 'Act 3 Instruction',
    325: 'Act 4',
    326: 'Act 4 Instruction',
    327: 'Act 4.1',
    328: 'Act 4.1 Instruction',
    329: 'Act 4.2',
    330: 'Act 4.2 Instruction',
    331: 'Act 4.3',
    332: 'Act 4.3 Instruction',
    333: 'Act 4.4',
    334: 'Act 4.4 Instruction',
    335: 'Act 4.5',
    336: 'Act 4.5 Instruction',
    337: 'Act 4.6',
    338: 'Act 4.6 Instruction',
    339: 'Act 4.7',
    340: 'Act 4.7 Instruction',
    341: 'Act 5',
    342: 'Act 5 Instruction',
    343: 'Act 5.1',
    344: 'Act 5.2',
    345: 'Act 5.3',
    346: 'Act 5.4',
    347: 'Act 5.5',
    348: 'Act 5.6',
    349: 'Act 5.7',
    350: 'Act 5.8',
    351: 'Act 5.9',
    352: 'Act 5.10',
    353: 'Act 5.11',
    354: 'Act 5.12',
    355: 'Act 6',
    356: 'Act 6 Instruction',
    357: 'Act 6.1',
    358: 'Act 6.2',
    359: 'Act 6.3',
    360: 'Act 6.4',
    361: 'Act 6.5',
    362: 'Act 6.6',
    363: 'Act 7',
    364: 'Act 7 Instruction 1',
    365: 'Act 7 Instruction 2',
    366: 'Act 8',
    367: 'Act 8 Instruction 1',
    368: 'Act 8 Instruction 2',
    369: 'Act 9',
    370: 'Act 9 Instruction',
    371: 'Act 10',
    372: 'Act 10 Instruction',
    373: 'Act 11',
    374: 'Act 11 Instruction 1',
    375: 'Act 11 Instruction 2',
    376: 'Act 12',
    377: 'Act 12 Instruction',
    378: 'Back',
    379: 'Confirm Registeration',
    380: 'Only one SCBS id per one LINE id',
    381: 'Confirm',
    382: 'Cancel',
    383: 'Cannot process',
    384: 'Due to',
    385: 'No account',
    386: 'Processing account',
    387: 'Wrong number',
    388: 'Change number',
    389: 'How to change',
    390: 'Please input correct number',
    391: 'Please select correct country',
    1000: 'คำชี้แจงที่สำคัญ (Disclaimer)',
    1001: '1. ภายใต้คำชี้แจงที่สำคัญนี้ ข้อมูลทั้งหมดที่ปรากฏอยู่ในบริการ InnovestX Line Official เป็นข้อมูลของบริษัทหลักทรัพย์ อินโนเวสท์ เอกซ์ จำกัด (“บริษัทฯ” หรือ “InnovestX”) โดยทันทีที่ท่านได้ add friend เพื่อใช้บริการนี้ ให้ถือว่าท่านได้ตกลงและรับทราบข้อกำหนดและเงื่อนไขตามที่ได้ระบุไว้ในคำชี้แจงที่สำคัญนี้ โดยบริษัทฯ มีสิทธิที่จะแก้ไขหรือเปลี่ยนแปลงคำชี้แจงที่สำคัญนี้ รวมทั้งเนื้อหาที่ระบุอยู่ในบริการนี้ หรือการยกเลิกการเข้าถึงข้อมูลไม่ว่าบางส่วนหรือทั้งหมดของบริการนี้ เมื่อใดก็ได้ตามที่บริษัทฯ เห็นสมควร โดยไม่จำต้องแจ้งให้ท่านทราบล่วงหน้า',
    1002: '2. ในกรณีที่มีความผิดพลาด บกพร่อง ล่าช้า หรือมีความเสียหายใด ๆ เกิดขึ้นจากเครื่องมือเพื่อการใช้บริการของท่าน หรือกระบวนการหรือวิธีการจัดส่งข้อความหรือข้อมูลหรือรายการการใช้บริการผ่าน LINE Application หรือระบบเครือข่ายโทรศัพท์มือถือ หรือระบบอินเทอร์เน็ต หรือจากการกระทำของผู้ให้บริการเครือข่ายโทรศัพท์มือถือ หรือผู้ให้บริการระบบอินเทอร์เน็ต หรือผู้ให้บริการ LINE Application ถือเป็นความรับผิดชอบของท่าน และ/หรือ ผู้ให้บริการ LINE Application และ/หรือ ผู้ให้บริการเครือข่ายโทรศัพท์มือถือ และ/หรือ ผู้ให้บริการระบบอินเทอร์เน็ต (แล้วแต่กรณี) โดยบริษัทฯ ไม่ต้องรับผิดชอบต่อท่านหรือบุคคลใดไม่ว่าในกรณีใด ๆ ทั้งสิ้น',
    1003: '3. บริษัทฯ ไม่ต้องรับผิดชอบในความผิดพลาด ความบกพร่อง หรือเหตุขัดข้องในการใช้บริการนี้ รวมทั้งท่านจะต้องไม่ใช้บริการนี้ เพื่อวัตถุประสงค์ใด ๆ ซึ่งเป็นสิ่งที่ผิดกฎหมาย และจะไม่ใช้บริการนี้ในลักษณะใด ๆ ซึ่งอาจจะทำให้เกิดความเสียหาย ทำให้ไร้ซึ่งความสามารถ หรือทำให้บริการนี้หรือเครือข่ายที่เชื่อมต่อกับบริการนี้ต้องเสียหาย หรือทำให้เกิดการรบกวนการใช้งานบริการนี้ของบุคคลอื่นใด นอกจากนี้ ท่านจะต้องไม่พยายามเข้าสู่บริการนี้ หรือระบบคอมพิวเตอร์ใด ๆ หรือเครือข่ายที่เชื่อมต่อกับบริการนี้ โดยปราศจากอำนาจไม่ว่าด้วยวิธีการอื่นใด',
    1004: '4. บริการนี้เป็นเพียงการให้ข้อมูลและแนะนำบริการการลงทุนของบริษัทฯ โดยมิได้เป็นการจัดการการลงทุน เสนอขายหรือเชื้อเชิญท่านเพื่อให้ซื้อผลิตภัณฑ์หรือใช้บริการใด ๆ ทั้งสิ้น ในกรณีที่ท่านประสงค์จะลงทุนในผลิตภัณฑ์การลงทุนอย่างใดอย่างหนึ่งโดยเฉพาะ โปรดติดต่อเจ้าหน้าที่ของบริษัทฯ และ/หรือ ช่องทางอื่นใดตามวิธีการที่บริษัทฯ กำหนด เพื่อรับการนำเสนอผลิตภัณฑ์การลงทุนนั้น ๆ ซึ่งรวมถึงคำอธิบายความเสี่ยงในการลงทุน ค่าธรรมเนียม ค่าใช้จ่าย และผลการดำเนินงานที่ผ่านมา (ถ้ามี) ที่อาจมีผลต่อการตัดสินใจลงทุน ทั้งนี้ ไม่ว่ากรณีใด ๆ ผลการดำเนินการในอดีตมิได้เป็นการรับประกันถึงผลการดำเนินงานในอนาคตและผลการดำเนินงานในอนาคตอาจไม่เป็นไปตามที่ได้คาดการณ์ไว้ ซึ่งขึ้นอยู่กับภาวะทางเศรษฐกิจ ภาวะตลาดและปัจจัยอื่น ๆ ประกอบด้วย',
    1005: '5. ข้อมูลที่ท่านได้จากบริการนี้ไม่ว่าจะเป็นข้อมูลเกี่ยวกับบัญชีลงทุนหรือข้อมูลอื่นใด (ซึ่งรวมถึงแต่ไม่จำกัดเพียง หรือบทวิเคราะห์ต่าง ๆ) เป็นเพียงข้อมูลในเบื้องต้นเท่านั้น โดยการเผยแพร่ข้อมูลและเอกสารต่าง ๆ ที่ปรากฏในบริการนี้บริษัทฯ ได้รวบรวมและจัดทำขึ้นภายใต้เจตนาสุจริตบนพื้นฐานของแหล่งข้อมูลที่น่าเชื่อถือ เพื่อประโยชน์และเป็นการอำนวยความสะดวกให้แก่ท่านเท่านั้น อย่างไรก็ตามบริษัทฯ ไม่สามารถรับรองและรับประกันถึงความถูกต้อง ความครบถ้วนสมบูรณ์ และความน่าเชื่อถือของข้อมูลและเอกสารดังกล่าวไม่ว่าในกรณีใด ๆ ทั้งสิ้น ทั้งนี้ หากท่านต้องการใช้ข้อมูล และ/หรือ เอกสารที่ปรากฏในบริการนี้เพื่อดำเนินการอย่างใดอย่างหนึ่ง ถือว่าเป็นการตัดสินใจและยอมรับความเสี่ยงของท่านเอง โดยบริษัทฯ ไม่ต้องรับผิดชอบในความเสียหายใด ๆ ที่เกิดขึ้น รวมทั้งท่านควรใช้ด้วยความรอบคอบ และ/หรือ ใช้ข้อมูลจากแหล่งข้อมูลอื่น ๆ ประกอบการพิจารณาด้วย',
    1006: '6. ท่านสามารถใช้บริการ Chatbot และ/หรือ Live Chat Support (ติดต่อเจ้าหน้าที่) บน InnovestX Line Official เพื่อสอบถามข้อมูลเพิ่มเติม และ/หรือ ตรวจสอบข้อมูลหรือสถานะในระบบต่าง ๆ ที่เกี่ยวข้อง และ/หรือ แจ้งปัญหาการใช้งาน รวมถึงขอรับแบบฟอร์มหรือเอกสารผ่านอีเมลได้ ทั้งนี้ ตามหลักเกณฑ์ เงื่อนไขและวิธีการที่บริษัทฯ กำหนด โดยการให้บริการดังกล่าวจะไม่รวมถึงการส่งคำสั่งซื้อขายแต่อย่างใด',
    2000: 'ประกาศนโยบายความเป็นส่วนตัวของบริษัทฯ',
    2001: 'โปรดอ่านเพิ่มเติมเกี่ยวกับประกาศนโยบายความเป็นส่วนตัวของ InnovestX อย่างละเอียด เพื่อเข้าใจถึงวิธีการที่ InnovestX เก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านและสิทธิของท่านที่เว็บไซต์ของ InnovestX',
};